/**
 *
 * @param {*} amount
 * @param {*} currency
 * @param {*} minimumFractionDigits
 * @param {*} maximumFractionDigits
 * @returns formatted amount string
 */
export const formatAmount = (
  amount,
  currency,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  const options = {
    minimumFractionDigits,
    maximumFractionDigits,
    ...(currency && { style: "currency", currency }),
  };

  return Number(amount).toLocaleString(undefined, options);
};

/**
 *
 * @param {*} num
 * @returns string with comma
 * @desc formatNumWithCommas(1000) => "1,000"
 */
export const formatNumWithCommas = (num) => {
  return num?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0;
};
